export default "__VITE_ASSET__99da0995__"